export default {
    methods: {
        resolveStatusVariant(status) {
            if (status === "billed") return "success";
            if (status === "cancelled") return "error";
            if (status === "draft") return "secondary";
            if (status === "pendding") return "warning";
        },
    }
}